import { TabStyles, Tooltip } from '@tableau/widgets';
import * as React from 'react';
import { style } from 'typestyle';

import { DialogAlertStyles } from '~commonInfra/components/dialogAlerts/DialogAlertStyles';
import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { tooltipMessage } from '~src/flow/components/FlowSuspendedIconWithTooltip';
import { classes, cssClass } from '~src/style';

const rootClass = 'WarningBanner';

const borderRadiusValue: string = '4px';

export const WARNING_BANNER_TOOLTIP_TESTID = 'warning-banner-tooltip';

const bannerWrapper = cssClass(rootClass, 'bannerWrapper', {
  display: 'flex',
  padding: 12,
  borderRadius: `${borderRadiusValue} 0 0 ${borderRadiusValue}`,
});

const errorIconStyle = cssClass(rootClass, 'errorIconStyle', {
  marginRight: 8,
});

export interface WarningBannerProps {
  message: string;
  tooltipMessages?: string[];
}

function getToolTipContent(messages: string[]) {
  return () => <>
    <div>
      { Messages.flowCannotBeRunForReasons() }
    </div>
    <ul>
    {messages.map((message) => (
      <li key={message}>{message}</li>
    ))}
    </ul>
  </>;
}

function getInfoAltContent(messages: string[]) {
  return  Messages.flowCannotBeRunForReasons() + '\n' + messages.map((message) => (message + '\n'));
}

export function WarningBanner(props: WarningBannerProps): JSX.Element {
  return (
    <div className={classes(bannerWrapper, DialogAlertStyles.warningStyle)}>
      <img src={imgPath('common_alert_warning.svg')} alt={''} className={errorIconStyle} />
      {props.message}
      {tooltipMessage !== undefined &&
        <div>
          <Tooltip
            testId={WARNING_BANNER_TOOLTIP_TESTID}
            getContent={getToolTipContent(props.tooltipMessages)}
          >
            <img className={style({paddingLeft: TabStyles.Spacing.SmallSpace})}
              src={imgPath('data_prep_info.svg')}
              alt={getInfoAltContent(props.tooltipMessages)} />
          </Tooltip>
        </div>}
    </div>
  );
}
